import { menuInfo } from "@shared/type/CommonType";

export type NonEmptyString = string & { __brand: "NonEmptyString" };

export type TargetTables = {
  header: string; // eg: "sal_soh"
  detail: string; // eg: "sal_sol"
};

export type ProvideDefaults = (row: any) => Partial<any> | void; // 초기값
export type ProvideDerived = (row: any) => Partial<any> | void; // 파생값
export type ValidateRow = (row: any) => string | null | void; // 에러 메시지 or null

export type FieldMap = {
  headerNoField?: string; //  "no_so"
  detailNoField?: string; //  "no_so"
  lineNoField?: string; //  "no_line"
};

//  공통 매핑 규칙 타입 (메뉴 종속 단어 금지)
export interface MappingRule {
  key: string; // 기준 컬럼명 (예: "cd_so", "cd_po")
  map: Record<string, any>; // { [값]: 속성세트 }
  transform?: (row: any, base: any) => Partial<any>; // (선택) 파생 가공
}

export interface ExcelUploadProps {
  Menuprops: menuInfo;
  grouping: string[];
  compareFields?: string[];
  provideDefaults?: ProvideDefaults; // 선택
  validateRow?: ValidateRow; // 선택  유효성체크(필수 아님 재고통제? lot체크)
  mappings?: MappingRule[]; // 여러 개 매핑 동시 적용 (수주형태/품목/거래처 등)
}

// 공통 채번 함수 형태 (실제 getNoSlip과 동일) 파라미터 전달용
export type SlipNumberingFn = (
  cd_module: string, // 모듈 코드 예: "SAL"
  no_line: number, // sys_notescount.no_line (직접 전달)
  cd_prefix: string, // 접두사 예: "SOR"
  dateValue: string, // 채번 기준 일자(값) - 2단에서 컬럼명으로부터 읽어 전달
  cd_menu: string // Menuprops.cd_menu
) => Promise<NonEmptyString>;

// 채번 스펙: useLine 제거, no_line 직접 전달
export type SlipNumberingSpec = {
  fn: SlipNumberingFn;
  options: {
    cd_module: string;
    no_line: number; // 필수: 숫자 그대로
    cd_prefix: string;
    dateField: string; // 헤더의 날짜 '컬럼명' (예: 'dt_so')  ※ 실제 값은 2단에서 읽어 fn에 전달
    cd_menu: string;
  };
};

export function toNonEmptyString(
  v: string | null | undefined,
  msg = "전표번호 채번 실패"
): NonEmptyString {
  if (typeof v !== "string" || v.trim() === "") throw new Error(msg);
  return v as NonEmptyString;
}

// 업서트 정책 (기존 upsert 구조)
export type ExcelUpload_UpsertPolicy = {
  mode: "create-only" | "create-or-append" | "full-replace";
  allowDelete: boolean; // true일 때만 D(Delete) 허용(보통 full-replace에서 사용)
};

// 2단(프리뷰/저장) 파라미터 (기존 Step2Args)
export type ExcelUpload_S02_Params = {
  validRows: any[];
  headerColumns: any[];
  detailColumns: any[];
  grouping: string[];

  controller: string; // 예: 'SN_SAL_SAO_REG_001_SAVE_01'
  numbering: SlipNumberingSpec; // 채번 스펙
  upsert: ExcelUpload_UpsertPolicy;
  tables: TargetTables;
  fieldMap?: FieldMap;
};
